import bb from "blingblingjs";
import {heightAuto, height0} from './transition-height-auto';

const state = {
    openFaqGroup: null,
    openFaq: null
};

const faqGroup      = bb(".js-fn-el__faq-group");
const faq           = bb(".js-fn-el__faq");
const closeFaq      = bb(".js-fn__close-faq");

faqGroup.on("click", e => {
    state.openFaqGroup = state.openFaqGroup == e.currentTarget.dataset.faqGroup ? null : e.currentTarget.dataset.faqGroup;
    updateDom();
});

faq.on("click", e => {
    e.stopPropagation();
    state.openFaq = state.openFaq == e.currentTarget.dataset.faq ? null : e.currentTarget.dataset.faq;
    updateDom();
});

closeFaq.on("click", e => {
    e.stopPropagation();
    state.openFaq = null;
    updateDom();
});

function updateDom() {
    faqGroup.forEach(el => {
        const contentEl = bb('.faqs__faq-group__inner', el)[0]
        if(state.openFaqGroup == el.dataset.faqGroup){
            el.classList.add('--is-open');
            heightAuto(contentEl);
        } else {
            el.classList.remove('--is-open');
            height0(contentEl)
        }
    });

    
    faq.forEach(el => {
        const contentEl = el.nextElementSibling
        if(state.openFaq == el.dataset.faq){
            el.classList.add('--is-open');
            heightAuto(contentEl);
        } else {
            el.classList.remove('--is-open');
            height0(contentEl)
        }
    });
    
    
}



